import imageUpload from './imageUpload'
imageUpload('.femanager_image')
